<template>
    <section id="contact-area" class="contact-area pt-120 pb-80 fix">
        <div class="container">
            <div class="row">
                <div class="col-xxl-5 col-xl-6 col-lg-6">
                    <div class="section-title-wrapper mb-15">
                        <h5 class="section-subtitle mb-20">Ju keni zgjedhur</h5>
                        <h2 class="section-title">{{ title }}</h2>
                        <div class="price-wrapper">
                            <h2 class="section-title price">
                                <template v-if="discount && discount > 0">
                                    <span class="original-price">{{ formattedPrice }} €</span>
                                    <span class="final-price">{{ formattedFinalPrice }} €</span>
                                    <span class="discount-pill">Zbritje {{ discount }}%</span>
                                </template>
                                <template v-else>
                                    {{ formattedPrice }} €
                                </template>
                            </h2>
                        </div>
                    </div>
                    <div class="contact-info mr-50 mr-xs-0 mr-md-0">
                        <h5 class="section-subtitle mb-20">
                            Për të vazhduar me anëtarësimin ju duhet të pajtoheni me termat dhe kushtet
                        </h5>
                        <div class="col-xxl-12 col-xl-12 mb-20">
                            <b-button type="button" variant="outline-primary" class="terms-btn" v-b-modal.modal-1 aria-label="Lexo termat dhe kushtet">
                                <span class="terms-icon" aria-hidden="true">📄</span>
                                Lexo termat dhe kushtet
                            </b-button>

                            <b-modal id="modal-1" title="Termat dhe Kushtet" dialog-class="modal-90w" size="lg" centered
                                hide-footer>
                                <iframe :src="pdfUrl" width="100%" style="border: none; height: 100%;"></iframe>
                            </b-modal>
                        </div>

                        <div class="col-xxl-12 col-xl-12 mb-20">
                            <b-form-checkbox id="checkbox-1" v-model="termatKushtet" name="checkbox-1" :value="true"
                                :unchecked-value="false">
                                Pranoj termat dhe kushtet
                            </b-form-checkbox>
                        </div>
                    </div>
                </div>
                <div v-if="termatKushtet" class="col-xxl-7 col-xl-6 col-lg-6">
                    <IndividualForm :title="title" :price="price" :packageId="packageId" :discount="discount"></IndividualForm>
                    <!-- <BiznesForm v-if="individual === false" :title="title" :price="price" :packageId="packageId"></BiznesForm> -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import IndividualForm from "./IndividualForm.vue";
// import BiznesForm from "./BiznesForm.vue";
export default {
    name: "ContactArea",
    props: ["title", "price", "discount", "packageID","pdfPath"],
    components: {
        IndividualForm,
        // BiznesForm
    },
    data() {
        return {
            termatKushtet: true,
            packageId: "",
            pdfUrl: "", // Initialize imageUrl as an empty string
        };
    },
    computed: {
        formattedPrice() {
            return (Number(this.price) || 0).toFixed(2);
        },
        finalPrice() {
            const p = Number(this.price) || 0;
            const d = Number(this.discount) || 0;
            return (p * (1 - d / 100));
        },
        formattedFinalPrice() {
            return this.finalPrice.toFixed(2);
        }
    },
    mounted() {
        this.packageId = this.$route.params.id;
        const domain = window.location.origin;
        this.pdfUrl = domain + this.pdfPath;

        const el = document.getElementById("contact-area");
        if (el) el.scrollIntoView();
    },
};
</script>
<style>
.modal-90w {
  max-width: 90% !important;
  width: 90% !important;
}

/* Optionally adjust height if needed */
.modal-90w .modal-content {
  height: 90vh;
  overflow-y: auto;
}

/* Price and discount styles */
.price-wrapper .price {
    display: flex;
    align-items: baseline;
    gap: 12px;
}
.original-price {
    text-decoration: line-through;
    color: rgba(0,0,0,0.4);
    font-size: 18px;
}
.final-price {
    color: #ff3b30;
    font-weight: 800;
    font-size: 26px;
}
.discount-pill {
    background: linear-gradient(135deg,#ff5a5f,#ff8966);
    color: #fff;
    padding: 6px 8px;
    border-radius: 6px;
    font-weight: 700;
    font-size: 12px;
}

@media (max-width: 576px) {
    .final-price { font-size: 20px; }
}

/* Modern terms button */
.terms-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    font-weight: 600;
}
.terms-btn .terms-icon {
    font-size: 18px;
    line-height: 1;
}
</style>

